var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotasFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75001 10.8333V7.5C8.75001 7.04167 8.37501 6.66667 7.91667 6.66667H4.58334V5H8.75001V3.33333H6.66667V2.5H5.00001V3.33333H3.75001C3.29167 3.33333 2.91667 3.70833 2.91667 4.16667V7.5C2.91667 7.95833 3.29167 8.33333 3.75001 8.33333H7.08334V10H2.91667V11.6667H5.00001V12.5H6.66667V11.6667H7.91667C8.37501 11.6667 8.75001 11.2917 8.75001 10.8333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9083 10.4333L11.1917 15.1417L8.83334 12.7833L7.65834 13.9667L11.1917 17.5L17.0833 11.6083L15.9083 10.4333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotasFilter);
export default __webpack_public_path__ + "static/media/quotas-filter.959a60267415f75c0bf34608b85abee3.svg";
export { ForwardRef as ReactComponent };